module.exports = __webpack_public_path__ + "img/73.4bd1c88e.jpg";